import { render, staticRenderFns } from "./Cauchy.vue?vue&type=template&id=738d1d9e&"
import script from "./Cauchy.vue?vue&type=script&lang=js&"
export * from "./Cauchy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Cauchy.vue"
export default component.exports